import React from "react";

/**
 * Map Header Component with title, stats, time filter, and refresh button
 */
const MapHeader = ({
  t,
  selectedDate,
  formatDateForAPI,
  filteredSchedules,
  selectedTimeFilter,
  setSelectedTimeFilter,
  getUniqueTimeRanges,
  loading,
  loadSchedules,
}) => {
  return (
    <div className="px-6 py-4 border-b border-gray-200">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-medium text-gray-900">
            {t("scheduleMap.title")}
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            {selectedDate
              ? t("scheduleMap.scheduleForDate", {
                  date: formatDateForAPI(selectedDate),
                })
              : t("scheduleMap.todaySchedules")}{" "}
            ({filteredSchedules.length} {t("scheduleMap.deliveries")})
          </p>
        </div>
        <div className="flex items-center space-x-3">
          {/* Time Filter Dropdown */}
          <div className="flex items-center space-x-2">
            <label
              htmlFor="time-filter"
              className="text-sm font-medium text-gray-700"
            >
              {t("scheduleMap.filterByTime")}:
            </label>
            <select
              id="time-filter"
              value={selectedTimeFilter}
              onChange={(e) => setSelectedTimeFilter(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-1 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="all">{t("scheduleMap.allTimes")}</option>
              {getUniqueTimeRanges.map((timeRange) => (
                <option key={timeRange} value={timeRange}>
                  {timeRange}
                </option>
              ))}
            </select>
          </div>

          <button
            onClick={loadSchedules}
            disabled={loading}
            className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
          >
            {loading ? (
              <svg
                className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-500"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            ) : (
              <svg
                className="-ml-1 mr-2 h-4 w-4 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
            )}
            {t("scheduleMap.refresh")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MapHeader;
